import { stockBalancesApi } from './balances';

export type StockProductsApi = typeof stockBalancesApi;

/**
 * Products stock slice currently delegates to balances endpoints.
 * Keep a factory surface for incremental modular extraction.
 */
export const createStockProductsApi = (): StockProductsApi => stockBalancesApi;

export * from './balances';
